import React from 'react';
import { DoNotCallList } from '../../../../../../../types/do-not-call-list';

type IProps = {
  doNotCallList: DoNotCallList;
};

const ClientAssociatedField: React.FC<IProps> = ({
  doNotCallList: { client },
}) => {
  if (!client) {
    return <p className="client-associated-field">All Clients (Global)</p>;
  }

  return <p className="client-associated-field">{client.companyName || '-'}</p>;
};

export default ClientAssociatedField;
